export const ENGAGEMENT_TIER = [
  { key: 1, text: 'Participant', value: 1 },
  { key: 2, text: 'Signatory', value: 2 },
  { key: 3, text: 'No Tier Selected', value: 3 },
  { key: 4, text: 'Not applicable', value: 4 },
];
export const CAMPAIGN_COLOR = 'var(--primary-600)';

/**
 * COLORS
 */
export const COLORS = {
  white: '#FFFFFF',
  black: '#000000',
  default: 'var(--primary-600)',
};

export const PLAN_TYPE = {
  free: 'free',
  'free-trial': 'free-trial',
  basic: 'basic',
  'basic-annually': 'basic-annually',
  pro: 'pro-monthly',
  premium: 'premium-monthly',
  enterprise: 'enterprise-monthly',
  appsumo: 'appsumo',
  'pro-annually': 'pro-annually',
  'premium-annually': 'premium-annually',
  'enterprise-annually': 'enterprise-annually',
};

// This object should be deprecated, used only in legacy signup.
export const TITLE = [
  'free',
  'pro',
  'enterprise',
  'pro-annually',
  'premium-annually',
  'premium',
  'enterprise-annually',
  'enterprise-monthly',
  'appsumo',
];

export const CAMPAIGN_TYPE = {
  PERSONALIZED: {
    value: 0,
    key: 'personalizedCampaign',
    text: 'Profile Message - Use a profile picture and logo in your campaign',
  },
  VIDEO: {
    value: 1,
    key: 'videoCampaign',
    text: 'Video Message - Use a video and logo in your campaign',
  },
  IMAGE: {
    value: 2,
    key: 'imageCampaign',
    text: 'Image Message - Use an image and logo in your campaign',
  },
  NEXT_GEN: {
    value: 3,
    key: 'nextGenCampaign',
    text: 'Next-gen - Use highly flexible fields to collect user-generated content',
  },
};

export const CAMPAIGN_TYPE_VALUE = {
  0: 'PERSONALIZED',
  1: 'VIDEO',
  2: 'IMAGE',
  3: 'NEXT_GEN',
};

export const VIDEO_SUBMISSION_TYPE = Object.freeze({
  RECORDING: 'recording',
  FILE_UPLOAD: 'file upload',
});

export const ACCEPT_TYPES = {
  VIDEO: 'video/*',
  IMAGE: 'image/*',
};

export const ELEMENT_ICONS = {
  // design elements
  RICH_TEXT_DESIGN_ELEMENT: 'font',
  VIDEO_DESIGN_ELEMENT: 'video-camera',
  IMAGE_DESIGN_ELEMENT: 'image',
  // input elements
  GENERIC_TEXT_AREA_INPUT: 'font',
  GENERIC_MEDIA_INPUT: 'video-camera',
  GENERIC_CHECKBOX_INPUT: 'check-square',
  GENERIC_FILE_INPUT: 'paperclip',
  SUBMISSION_TYPE_SELECTOR: 'list-alt',
};

export const ELEMENT_ICONS_V2 = {
  // design elements
  RICH_TEXT_DESIGN_ELEMENT: 'Type',
  VIDEO_DESIGN_ELEMENT: 'Video',
  IMAGE_DESIGN_ELEMENT: 'Image',
  // input elements
  GENERIC_TEXT_INPUT: 'Minus',
  GENERIC_TEXT_AREA_INPUT: 'Menu',
  GENERIC_MEDIA_INPUT: 'Video',
  GENERIC_CHECKBOX_INPUT: 'Square',
  GENERIC_FILE_INPUT: 'Image',
  FIRST_NAME_INPUT: 'Type',
  LAST_NAME_INPUT: 'Type',
  EMAIL_INPUT: 'Mail',
  PHONE_INPUT: 'Phone',
  ADDRESS_INPUT: 'MapPin',
  SUBMISSION_TYPE_SELECTOR: 'List',
};



// WEBPACK FOOTER //
// ./src/constants/index.js